###
This provides dropdown functionality.

Dropdowns should be structured like this:

```
<div rj-dropdown>
  <button rj-dropdown-toggle>
    Toggle Dropdown
  </button>
  <div rj-dropdown-content>
    <ul>
      <li>Item 1</li>
    </ul>
    <ul>
      <li>Item 1</li>
    </ul>
    <ul>
      <li>Item 1</li>
    </ul>
  </div>
</div>
```

Alternately, you can use classes in place of attributes (``.rj-dropdown``,
``.dropdown-toggle``, ``.dropdown-content``).

When an element that matches ``[rj-dropdown-toggle], .dropdown-toggle`` is
clicked, the ``.open`` class will be set on the parent
``[rj-dropdown], .rj-dropdown`` element. The modal will be hidden when the user
clicks.

To prevent the dropdown from being closed when the user clicks, capture the
click event and use ``event.stopPropagation()``.

There are two events broadcast for each dropdown: ``dropdownopen`` and
``dropdownclose``. You can subscribe to these using jQuery:

```
$(".rj-dropdown.foo").on "dropdownopen", () ->
  console.log("Dropdown opened")

$(".rj-dropdown.foo").on "dropdownclose", () ->
  console.log("Dropdown closed")
```
###

getClosestDropdown = (element) ->
  openedDropdown = null

  toggle = element.closest(".dropdown-toggle:not(:disabled):not([disabled]), [rj-dropdown-toggle]:not(:disabled):not([disabled])")
  if toggle.length
    parent = toggle.closest ".rj-dropdown, [rj-dropdown]"
    dropdown = parent.find ".dropdown-content, [rj-dropdown-content]"
    if parent.length and dropdown.length
      return parent

  return $()

# Close every dropdown except (optionally) the specified dropdown
closeDropdowns = (dropdownToExclude) ->
  $(".rj-dropdown.open, [rj-dropdown].open").each () ->
    unless dropdownToExclude? and $(@).is(dropdownToExclude)
      $(@).removeClass("open")
        .trigger("dropdownclose")
  dropdownToExclude

openDropdown = (dropdown) ->
  unless dropdown.is(".open")
    dropdown.addClass("open")
    dropdown.trigger("dropdownopen")

    closeDropdowns(dropdown)

  return dropdown

openClosestDropdown = (element) ->
  closestDropdown = getClosestDropdown(element)
  openDropdown(closestDropdown)

toggleClosestDropdown = (element, event) ->
  closestDropdown = getClosestDropdown(element)

  if closestDropdown.length is 0 or closestDropdown.is(".open")
    closeDropdowns()
  else
    openDropdown(closestDropdown)
    event?.stopPropagation()
    event?.preventDefault()

  return closestDropdown

clickHandler = (event) ->
  toggleClosestDropdown($(event.target), event)

getClosestTooltip = (target) ->
  toggle = target.closest("[rj-tooltip-toggle]")
  if toggle.length > 0
    parent = toggle.closest("[rj-tooltip-container]")
    tooltip = parent.find("[rj-tooltip]")
    if parent.length > 0 and tooltip.length > 0
      return tooltip

  return $()

ANIMATION_END = "animationend webkitAnimationEnd oAnimationEnd msAnimationEnd"

hideTooltip = (tooltip) ->
  tooltip.removeClass("fade-in")
    .off(ANIMATION_END)
    .addClass("fade-out")
    .one ANIMATION_END, () ->
      tooltip.removeClass("visible fade-out")
    .trigger("tooltipClose")

showTooltip = (tooltip) ->
  tooltip.removeClass("fade-out")
    .off(ANIMATION_END)
    .addClass("visible fade-in")
    .one ANIMATION_END, () ->
      tooltip.removeClass("fade-in")
    .trigger("tooltipOpen")

$(document).ready () ->
  jQuery.fn.extend

    openDropdown: () ->
      openClosestDropdown($(@))

    closeDropdowns: (dropdownToExclude) ->
      closeDropdowns()

    toggleDropdown: (event) ->
      toggleClosestDropdown($(@))

    showTooltip: () ->
      showTooltip($(@))

    hideTooltip: () ->
      hideTooltip($(@))

  $(document).click(clickHandler)

  # Close any open dropdowns when ESC is pressed.
  $(document).on "keydown", (event) ->
    if event.which is 27
      if $(".rj-dropdown.open, [rj-dropdown].open").length > 0
        closeDropdowns()
        event.stopImmediatePropagation()
